import FinancialTable from './FinancialTable';

export default FinancialTable;
